import { render } from "./VideoPlayer.vue?vue&type=template&id=eaa8fad2"
import script from "./VideoPlayer.vue?vue&type=script&lang=js"
export * from "./VideoPlayer.vue?vue&type=script&lang=js"
script.render = render

export default script